export const isUrlExternal = (url: string) => {
  const lUrl = url.trim().toLowerCase();
  return lUrl.startsWith("http://") || lUrl.startsWith("https://");
};
